<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @save="save" @add="add" @search="search" @reflash="reflash" @del="del" @exps="exp" @imp="imp"
                    @print="print" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <!-- 功能按钮 -->
                <el-tabs v-model="act" @tab-click="handleClick">
                    <el-tab-pane :label="$t('getapi[2790]')" name="0"></el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2791]')" name="1">
                        <el-button type="primary" size="mini" @click="batchRelease" :disabled="selectDetailData.length < 1">{{$t('getapi[3056]')}}</el-button>
                        <el-button type="primary" size="mini" @click="batchDel" :disabled="selectDetailData.length < 1">{{$t('getapi[7241]')}}</el-button>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2792]')" name="2">
                        <el-button type="primary" size="mini" @click="batchClose" :disabled="selectDetailData.length < 1">{{$t('getapi[7992]')}}</el-button>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[2793]')" name="3"></el-tab-pane>
                </el-tabs>
                <!-- 表格 -->
                <wTable
                        id="xpane-0"
                        :data="datajson"
                        :loading="loading"
                        queryData="SALPickNoticeViewInfo"
                        :filter_language="['StatusName']"
                        :filter_date="['Delivery_Date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="checkflag"
                ></wTable>
                <!--<el-table
                        :data="datajson"
                        v-loading="loading"
                        ref="singleTable"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight - reduceTableHeight"
                        tab-click="selectInfo(0)"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        @selection-change="handleSelectionChange"
                        @current-change="handleCurrentChanges"
                        :highlight-current-row="true"
                        @row-click="edits"
                        @row-dblclick="openEdit"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" width="20" v-if="SelectIndex == 1 || SelectIndex == 2"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Exclusively_Id" label="ID"
                                     v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Customer_Order" :label="$t('getapi[1596]')" sortable>
                        <template scope="scope">
                            <input
                                    type="text"
                                    class="fsd clerinput"
                                    @keydown="shows($event, scope.$index)"
                                    @keyup="show($event, scope)"
                                    v-model="scope.row.Customer_Order"
                                    readonly
                            />
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ExClusively_Id"
                                     :label="$t('getapi[2287]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="customer_id"
                                     :label="$t('getapi[2583]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="customer_name"
                                     :label="$t('getapi[2584]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="StatusName"
                                     :label="$t('getapi[2784]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Delivery_Date"
                                     :label="$t('getapi[2785]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Delivery_Person" :label="$t('getapi[2786]')"
                                     width="130px" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Notice_Person" :label="$t('getapi[2787]')"
                                     width="130px" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_time"
                                     :label="$t('getapi[135]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_person"
                                     :label="$t('getapi[410]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"
                                     align="right" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_time"
                                     :label="$t('getapi[2789]')" sortable></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person"
                                     :label="$t('getapi[2788]')" sortable></el-table-column>
                    &lt;!&ndash;<el-table-column show-overflow-tooltip :label="$t('basic.edit')" width="70" align="center">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]')
                                }}
                            </el-button>
                        </template>
                    </el-table-column>&ndash;&gt;
                </el-table>-->
                <!-- 表格 -->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <!-- 编辑弹框 -->
                <div class="box" style="height: 125px;">
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" icon="" @click.native="bathcre"
                                   :disabled="!btn.copyoldco">{{$t('getapi[2832]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click.native="tall" :disabled="!btn.release">{{$t('getapi[3085]')}}
                        </el-button>
                        <el-button type="primary" size="mini" icon="" @click.native="closes" :disabled="!btn.close">
                            {{$t('getapi[2345]')}}
                        </el-button>
                    </div>
                    <div style="width:800px;min-width: 800px">
                        <table>
                            <tr>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[2287]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input v-model="formInline.Head.exclusively_id" :placeholder="$t('getapi[2287]')"
                                               size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[2785]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-date-picker
                                            v-model="formInline.Head.delivery_date"
                                            type="date"
                                            class="mcolor"
                                            :placeholder="$t('getapi[2785]')"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%"
                                            size="mini"
                                            :readonly="formInline.Head.status >= 1"
                                            :class="{'readO':formInline.Head.status >= 1}"
                                    ></el-date-picker>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[2786]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <routejump :urlNo="6" v-show="formInline.Head.status < 1">
                                    <el-input
                                            v-model="formInline.Head.delivery_person"
                                            :placeholder="$t('getapi[2786]')"
                                            class="mcolor"
                                            readonly
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input
                                            v-model="formInline.Head.delivery_person"
                                            :placeholder="$t('getapi[2786]')"
                                            v-show="formInline.Head.status >= 1"
                                            :readonly="true" class="readO"
                                            size="mini"
                                    ></el-input>
                                </td>
                                <td style="width:80px;min-width: 80px"><span>{{ $t('getapi[3915]') }}</span></td>
                                <td style="width:120px;min-width: 120px">
                                    <el-input v-model="formInline.Head.contract_info" :placeholder="$t('getapi[3915]')"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{ $t('getapi[1596]') }}</span></td>
                                <td>
                                    <routejump :urlNo="39" v-show="formInline.Head.status < 1">
                                    <el-input
                                            v-model="formInline.Head.customer_order"
                                            :placeholder="$t('getapi[1596]')"
                                            class="mcolor"
                                            size="mini"
                                            readonly
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen" :disabled="formInline.Lists.length > 0"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input
                                            v-show="formInline.Head.status >= 1"
                                            v-model="formInline.Head.customer_order"
                                            :placeholder="$t('getapi[1596]')"
                                            size="mini"
                                            readonly
                                    ></el-input>
                                </td>
                                <td><span>{{ $t('getapi[135]') }}</span></td>
                                <td><el-input v-model="formInline.Head.create_time" :placeholder="$t('getapi[135]')"
                                               size="mini" :readonly="true" class="readO"></el-input></td>
                                <td><span>{{ $t('getapi[2807]') }}</span></td>
                                <td><el-input v-model="formInline.Head.notice_person"
                                              :placeholder="$t('getapi[2807]')" size="mini" :readonly="true" class="readO"></el-input></td>
                                <td><span>{{ $t('getapi[552]') }}</span></td>
                                <td><el-input :value="expStatus(formInline.Head.status)" :placeholder="$t('getapi[552]')"
                                               size="mini" :readonly="true" class="readO"></el-input></td>
                            </tr>
                            <tr>
                                <td><span>{{ $t('getapi[4169]') }}</span></td>
                                <td><el-input v-model="formInline.Head.plan_delivery_date" :placeholder="$t('getapi[4169]')"
                                              size="mini" :readonly="true" class="readO"></el-input></td>
                                <td><span>{{ $t('getapi[2789]') }}</span></td>
                                <td><el-input v-model="formInline.Head.audit_time" :placeholder="$t('getapi[2789]')"
                                              size="mini" :readonly="true" class="readO"></el-input></td>
                                <td><span>{{ $t('getapi[2788]') }}</span></td>
                                <td><el-input v-model="formInline.Head.audit_person" :placeholder="$t('getapi[2788]')"
                                              size="mini" :readonly="true" class="readO"></el-input></td>
                            </tr>
                            <tr>
                                <td><span>{{ $t('getapi[143]') }}</span></td>
                                <td colspan="5"><el-input v-model="formInline.Head.remark" :placeholder="$t('getapi[143]')"
                                                          size="mini"></el-input></td>
                            </tr>
                        </table>
                    </div>
                    <!--<div class="bbl">
                        <span>{{ $t('getapi[2287]') }}</span>
                        <el-input v-model="formInline.Head.exclusively_id" :placeholder="$t('getapi[2287]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2785]') }}</span>
                        &lt;!&ndash; <el-input v-model="formInline.Head.delivery_date" :placeholder="$t('getapi[2785]')" style="width: 120px" size="mini"></el-input> &ndash;&gt;
                        <el-date-picker
                                v-model="formInline.Head.delivery_date"
                                type="date"
                                class="mcolor"
                                :placeholder="$t('getapi[2785]')"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                style="width: 150px"
                                size="mini"
                                :readonly="formInline.Head.status >= 1"
                                :class="{'readO':formInline.Head.status >= 1}"
                        ></el-date-picker>
                        <span>{{ $t('getapi[2786]') }}</span>
                        &lt;!&ndash; <el-input v-model="formInline.Head.delivery_person" :placeholder="$t('getapi[2786]')" style="width: 120px" size="mini"></el-input> &ndash;&gt;

                        <el-input
                                v-model="formInline.Head.delivery_person"
                                :placeholder="$t('getapi[2786]')"
                                style="width: 120px"
                                class="mcolor"
                                readonly
                                v-show="formInline.Head.status < 1"
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="peop"></i>
                        </el-input>
                        <el-input
                                v-model="formInline.Head.delivery_person"
                                :placeholder="$t('getapi[2786]')"
                                style="width: 120px"
                                v-show="formInline.Head.status >= 1"
                                :readonly="true" class="readO"
                                size="mini"
                        ></el-input>
                        <span>{{ $t('getapi[3915]') }}</span>
                        <el-input v-model="formInline.Head.contract_info" :placeholder="$t('getapi[3915]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[1596]') }}</span>
                        &lt;!&ndash; <el-input v-model="formInline.Head.contract_info" :placeholder="$t('getapi[1596]')" style="width: 120px" size="mini"></el-input> &ndash;&gt;
                        <el-input
                                v-show="!orderNoChage"
                                v-model="formInline.Head.customer_order"
                                :placeholder="$t('getapi[1596]')"
                                class="mcolor"
                                style="width:120px"
                                size="mini"
                                readonly
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="conopen" :disabled="formInline.Lists.length > 0"></i>
                        </el-input>
                        <el-input
                                v-show="orderNoChage"
                                v-model="formInline.Head.customer_order"
                                :placeholder="$t('getapi[1596]')"
                                style="width:120px"
                                size="mini"
                                readonly
                        ></el-input>
                        <span>{{ $t('getapi[135]') }}</span>
                        <el-input v-model="formInline.Head.create_time" :placeholder="$t('getapi[135]')"
                                  style="width: 150px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2807]') }}</span>
                        <el-input v-model="formInline.Head.notice_person"
                                  :placeholder="$t('getapi[2807]')" style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[552]') }}</span>
                        <el-input :value="expStatus(formInline.Head.status)" :placeholder="$t('getapi[552]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[4169]') }}</span>
                        <el-input v-model="formInline.Head.plan_delivery_date" :placeholder="$t('getapi[4169]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2789]') }}</span>
                        <el-input v-model="formInline.Head.audit_time" :placeholder="$t('getapi[2789]')"
                                  style="width: 150px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2788]') }}</span>
                        <el-input v-model="formInline.Head.audit_person" :placeholder="$t('getapi[2788]')"
                                  style="width: 120px" size="mini" :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[143]') }}</span>
                        <el-input v-model="formInline.Head.remark" :placeholder="$t('getapi[143]')" style="width: 360px"
                                  size="mini"></el-input>
                    </div>-->
                </div>
                 <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
                    <el-tab-pane :label="$t('getapi[2797]')" name="0" id="xdetilpane-0">
                        <div>
                            <el-button type="primary" size="mini" @click="addlines"
                                    :disabled="!btn.rowadd">{{$t('getapi[878]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="dellines"
                                    :disabled="!btn.rowdel">{{$t('getapi[3889]')}}
                            </el-button>
                        </div>
                    <vxe-table
                            :data="formInline.Lists"
                            header-row-class-name="headerclass"
                            @checkbox-change="linedelsel"
                            @checkbox-all="linedelselAll"
                            @checkbox-range-end="linedelsel"
                            :highlight-current-row="false"
                            stripe
                            border
                            resizable
                            :height="tableHeight - 180"
                            size="mini"
                            style="width: 100%;"
                            @sort-change="sortChange"
                            :default-sort="sortRule"
                            :row-class-name="tableRowClassNameDetail"
                            :checkbox-config="{highlight: true, range: true}"
                            :mouse-config="{selected:true, extension: true}"
                            ref="singleTable1"
                    >
                        <vxe-table-column type="checkbox" align="center" width="40"></vxe-table-column>
                        <vxe-table-column field="statusname" :title="$t('getapi[552]')" sortable align="left"
                                        width="80">
                            <template scope="scope">
                                <span>{{ scope.row.statusname | lanchange}}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="line_no" :title="$t('getapi[1425]')" sortable align="right"
                                        width="80"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="co_line_no" :title="$t('getapi[2799]')" sortable align="right"
                                        width="150"></vxe-table-column>
                        <vxe-table-column field="co_line_part" :title="$t('getapi[2800]')" sortable width="120">
                            <template slot-scope="scope" v-show="editf">
                                <el-input
                                        v-show="formInline.Head.status < 1"
                                        v-model="scope.row.co_line_part"
                                        :placeholder="$t('getapi[2800]')"
                                        class="mcolor"
                                        readonly
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="ssf(scope)"></i>
                                </el-input>
                                <el-input
                                        v-show="formInline.Head.status >= 1"
                                        v-model="scope.row.co_line_part"
                                        :placeholder="$t('getapi[2800]')"
                                        style="width:120px"
                                        size="mini"
                                        readonly
                                ></el-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="remark2" :title="remark2" sortable align="left"
                                        width="170"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="part_version" :title="$t('getapi[2801]')" sortable
                                        width="120"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="spec" :title="$t('getapi[125]')" sortable
                                        width="120"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="page_no" :title="$t('getapi[133]')" sortable
                                        width="120"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[876]')" sortable
                                        width="100"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="item_name" :title="$t('getapi[546]')" sortable
                                        width="120"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="cuspart_id" :title="$t('getapi[2390]')" sortable
                                        width="150"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="cuspart_name" :title="$t('getapi[2391]')" sortable
                                        width="120"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="sales_qty" :title="$t('getapi[3602]')" sortable align="right"
                                        width="100"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="need_deliver_qty" :title="$t('getapi[2803]')" sortable
                                        align="right" width="120"></vxe-table-column>
                        <vxe-table-column field="plan_deliver_qty" :title="$t('getapi[2804]')" sortable
                                        align="right" width="100">
                            <template slot-scope="scope" v-show="editf">
                                <el-input v-model="scope.row.plan_deliver_qty" :placeholder="$t('getapi[2804]')"
                                        align="right" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="qty_onhand" :title="$t('getapi[2805]')" sortable align="right"
                                        width="100"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="qty_onyuliu" :title="$t('getapi[2806]')" sortable align="right"
                                        width="120"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="create_person" :title="$t('getapi[410]')" sortable align="right"
                                        width="100"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="create_time" :title="$t('getapi[135]')" sortable
                                        width="170"></vxe-table-column>
                        <vxe-table-column field="remark" :title="$t('getapi[143]')" sortable width="80">
                            <template slot-scope="scope" v-show="editf">
                                <el-input v-model="scope.row.remark" :placeholder="$t('getapi[143]')"></el-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="customer_item" :title="$t('getapi[2707]')" sortable
                                        width="100"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="package_size" :title="$t('getapi[1307]')" sortable align="right"
                                        width="100"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="itemvernum" :title="$t('getapi[6700]')" sortable align="left"
                                        width="170"></vxe-table-column>
                        
                        <vxe-table-column show-overflow-tooltip field="remark1" :title="$t('getapi[2720]')" sortable align="left"
                                        width="150"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="cus_chartnum" :title="$t('getapi[8595]')" sortable align="left"
                                        width="150"></vxe-table-column>
                        <vxe-table-column show-overflow-tooltip field="move_direction" :title="$t('getapi[554]')" sortable align="left"
                                        width="150"></vxe-table-column>
                                        
                    </vxe-table>
                    </el-tab-pane>
                 </el-tabs>

                <!-- 编辑弹框 -->
            </li>
        </ul>
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="SelectIndexs"
                        :page-sizes="[50,100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->

        <serce :isVisible="isVisible" queryData="SALPickNoticeViewInfo " ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[2822]')" queryData="SALPickNoticeViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 销售人员 -->
        <!--<employee :isVisible="false" @getemployee="getemployee" ref="inputemp"></employee>-->
        <selector :isVisible="false" :selectType="6" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="inputemp"></selector>
        <!-- 销售件 -->
        <!--<salpart :isVisible="false" @getsalpart="getsalpart" ref="input"></salpart>-->
        <selector :isVisible="false" :isBatch=true :selectType="1" :isSplitPage=true :postUrl="'Basic/Popup/GetSalPartDataList'"
                  @callback="getsalpart" ref="input"></selector>
        <selector :isVisible="false" :selectType="1" :isSplitPage=true :postUrl="'Basic/Popup/GetSalPartDataList'"
                  @callback="getsalpart" ref="inputsingle"></selector>
        <!-- 订单 -->
        <!--<salorder :isVisible="false" @getsalorder="getsalorder" ref="inputs"></salorder>-->
        <selector :isVisible="false" :selectType="0" :isSplitPage=true :postUrl="'Basic/Popup/GetDeliveryBillDataList'"
                  @callback="getsalorder" ref="inputs"></selector>
        <!-- 工作中心弹框 -->
        <!-- <wcenter :isVisible="wcentervisible" @getwcenter="getwcenter" ref="rout"></wcenter> -->
        <el-dialog v-dialogDrag :visible.sync="isShowDialog" :title="title" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" :autosize="{ minRows: 15}"  v-model="content"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowDialog = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmSave" size="mini">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import { Loading } from 'element-ui';
    export default {
        name: 'salshipmentsinform',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                formInline: {
                    IsConfirm: 0,
                    Head: {
                        exclusively_id: '',
                        customer_order: '',
                        field: '',
                        delivery_date: '',
                        delivery_person: '',
                        notice_person: '',
                        create_person: '',
                        create_time: '',
                        status: '',
                        statusname: '',
                        old_status: 0,
                        remark: '',
                        update_person: '',
                        update_date: '',
                        audit_person: '',
                        audit_time: '',
                        contract_info: '',
                        plan_delivery_date:'',
                    },
                    Lists: []

                },
                oldFormInline:'',
                formInlines: {
                    version_status: true,
                    enable_flag: true
                },
                ids: '',
                userinfo: {},
                user: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('salshipmentsinform'),
                SelectIndex: 0,
                oldSelectIndex: 0,
                SelectIndexs: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                itevisible: false, //物料弹框
                ProPositionList: [],
                rouvisible: false,
                roushowindex: 0,
                wcentervisible: false,
                wcentershowindex: 0, //订单选择行
                editf: false,
                act: '0',
                currentRow: null,
                lineid: [],
                DeliveryTermList: [], //交货条款
                TransMode: [], //运输方式,
                selectDetailData: [], // 选择的数据的集合
                btn: {
                    //从订单批量生成
                    copyoldco: false,
                    //下达
                    release: false,
                    //强制关闭
                    close: false,
                    //新增明细行
                    rowadd: false,
                    //删除明细行
                    rowdel: false
                },
                addoredit: 1,
                order_No: '',//用于获取详情的唯一编号
                dataDetailLineNo: 1,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                isShowDialog: false,
                title: '',//标题
                content: '',//内容
                remark2:'',//备注2特殊处理
                checkflag: false,
                orderNoChage:false,
                scrollTop:0,
                scrollTop1:0,
                sortRule: {property:null,order:null},
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.getselect();
            // that.$http.urlpost('Eng/Routings/GetProPositionList', {}, function (res) {
            //     console.log(res);
            //     if (res.Success == 1) {
            //         that.ProPositionList = res.DataContent;
            //     }
            // });
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'salelin' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getdlist(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('salshipmentsinform', that)
            var users = JSON.parse(sessionStorage.getItem('userData'));
            that.userinfo = users;
            that.user = that.userinfo.username
            
            that.remark2="备注2";
            if(that.userinfo.Login_DB=="MY"){
                that.remark2="下一道工序";
            }
            console.log(that.userinfo);
            that.$limits.dragControllerDiv();
            //that.intidata();
            that.confirmAdd();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[2822]"),this.$t("getapi[14]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SALPickNoticeViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.orderNoChage=true;
                if(that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)){
                    that.orderNoChage=false;                     
                }
                else{
                    if(that.formInline.Lists.length==0){
                        that.orderNoChage=false;
                    }
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 106, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 105, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 106, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 106, 1) == 2) {
                        if (that.$limits.authority('plv3', 106,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 106) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                                if (that.formInline.Head.status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }
                            }
                        }
                        if (that.$limits.authority('plv3', 106, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                                if (that.formInline.Head.status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                //从订单批量生成
                that.btn.copyoldco = true;
                that.btn.rowadd = true;
                that.btn.rowdel = true;
                 that.btn.release = false;
                if (that.formInline.Head.status != 0) {
                    that.btn.rowadd = false;
                }
                if (that.$limits.authority('plv3', 106, 1) == 0) {
                    //查询级
                    //从订单批量生成
                    that.btn.rowdel = false;
                } else {
                    if (that.$limits.authority('plv4', 53, 1) == 0) {
                        that.btn.rowdel = false;
                    }
                    else {
                        if (that.formInline.Head.status != 0) {
                            that.btn.rowdel = false;
                        }
                        if (that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                            that.btn.rowdel = false;
                        }
                    }
                }

                //从订单批量生成
                if (that.$limits.authority('plv3', 106, 1) == 0) {
                    //查询级
                    //从订单批量生成
                    that.btn.copyoldco = false;
                } else {
                    if (that.formInline.Head.status != 0) {
                        //从订单批量生成
                        that.btn.copyoldco = false;
                    }
                    if (that.$limits.fnIsEmpty(that.formInline.Head.customer_order)) {
                        //从订单批量生成
                        that.btn.copyoldco = false;
                    }
                }
                //下达

                if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                    that.btn.release = true;
                    if (that.$limits.authority('plv3', 106, 1) == 0) {
                        //查询级
                        that.btn.release = false;
                    } else {
                        if (that.$limits.authority('plv4', 54, 1) == 0) {
                            //查询级
                            that.btn.release = false;
                        } else {
                            if (that.formInline.Head.status != 0) {
                                that.btn.release = false;
                            }
                        }
                    }
                }
                if (!that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)) {
                    //强制关闭
                    that.btn.close = true;
                    if (that.$limits.authority('plv3', 106, 1) == 0) {
                        //查询级
                        that.btn.close = false;
                    } else {
                        if (that.$limits.authority('plv4', 55, 1) == 0) {
                            //查询级
                            that.btn.close = false;
                        } else {
                            if (that.formInline.Head.status != 1) {
                                that.btn.close = false;
                            }
                        }
                    }
                }
            },
            //tabs
            handleClick(tab, event) {
                let that = this
                this.SelectIndex = tab.name;
                this.act = tab.name
                console.log(tab.name);
                this.intidata();
                if(tab.name == '1' || tab.name=='2'){
                    that.checkflag = true
                    that.tableOption.height =  Common.tableHeight2 - Common.reduceTableHeight1
                } else {
                    that.checkflag = false
                    that.tableOption.height =  Common.tableHeight2 - Common.reduceTableHeight2
                }
                this.$forceUpdate()
                this.colsort()
            },
            tableRowClassNameDetail({row, rowIndex}){
                let that = this
                row.index = rowIndex;
                if(!that.$limits.fnIsEmpty(row.move_direction)){
                    return 'red'
                }
                
            },
            // 销售员
            peop() {
                this.$refs.inputemp.clearInput(true);
            },
            // 获取
            getemployee(e) {
                this.formInline.Head.delivery_person = e.name;
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //订单
            conopen() {
                console.log('ding');
                this.$refs.inputs.clearInput(true, 0);
            },
            //获取订单信息
            getsalorder(val) {
                console.log(val);
                this.formInline.Head.contract_info = val.contract_info;
                this.formInline.Head.customer_order = val.customer_order;
                this.formInline.Head.customer_name = val.customer_name;
                this.formInline.Head.plan_delivery_date = val.delivery_date;

                this.btnauthority();
            },
            //销售件
            ssf(row) {
                let that = this
                console.log(row)
                if (this.formInline.Head.customer_order) {
                    this.wcentershowindex = row.$rowIndex;
                    let param = {
                        currency_code:'',
                        customer_code:that.formInline.Head.customer_order,
                    }
                    console.log(param)
                    this.$refs.inputsingle.clearInput(true, param);
                } else {
                    this.$message.error(this.$t('getapi[2824]'));
                }
            },
            //获取销售件信息
            getsalpart(val) {
                let that = this;
                let datetime = Common.methods.getDatetime()
                let checkt = true;
                console.log(val)
                val = val.filter(item => {
                    return that.formInline.Lists.every(item2 => {
                        return item.exclusively_id != item2.co_line_id
                    });
                });
                let arr = []
                if (checkt) {
                    if(that.wcentershowindex == -1){
                        that.dataDetailLineNo = 1
                        for (let i = 0; i < that.formInline.Lists.length; i++) {
                            if (that.formInline.Lists[i].line_no >= that.dataDetailLineNo) {
                                that.dataDetailLineNo = that.formInline.Lists[i].line_no + 1
                            }
                        }
                        for(let i = 0;i< val.length;i++){
                            that.formInline.Lists = [...that.formInline.Lists,{
                                exclusively_id: '',
                                relation_id: '',
                                line_no: that.dataDetailLineNo++,
                                co_line_id: val[i].exclusively_id,
                                co_line_no: val[i].line_no,
                                co_line_part: val[i].sales_part,
                                part_version: val[i].part_version,
                                co_line_part_id: val[i].sales_part_id,
                                co_line_inv_part_num: val[i].part_no,
                                sales_qty: val[i].sales_qty,
                                need_deliver_qty: '',
                                plan_deliver_qty: '',
                                qty_onhand: '',
                                qty_onyuliu: '',
                                create_person: that.userinfo.username,
                                create_time: datetime,
                                remark: '',
                                status: '',
                                statusname: '',
                                item_code: '',
                                item_name: '',
                                cuspart_id: val[i].cuspart_id,
                                cuspart_name: val[i].cuspart_name,
                                customer_item: val[i].customer_item,
                                package_size: val[i].package_size,
                                itemvernum:val[i].itemvernum,
                                remark2:val[i].remark2,
                                remark1:val[i].remark1,
                                cus_chartnum:val[i].cus_chartnum,                                
                                spec:val[i].spec,
                                page_no:val[i].page_no,
                                isadd: 1,
                            }]
                        }
                        for(let i = 0;i<val.length;i++){
                            arr = [...arr,{
                                colineid: val[i].exclusively_id,
                                partid: val[i].part_no,
                                Change_Rate: val[i].change_rate
                            }]
                        }
                        let parm = {
                            ls: arr
                        }
                        that.$http.urlpost('/Sal/Out/GetBatchSalPartRelationQty', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                let data = res.DataContent
                                for(let i=0;i<data.length;i++){
                                    for(let j=0;j<that.formInline.Lists.length;j++){
                                        if(data[i].colineid == that.formInline.Lists[j].co_line_id && data[i].partid == that.formInline.Lists[j].co_line_inv_part_num){
                                            that.formInline.Lists[j].need_deliver_qty = that.formInline.Lists[j].sales_qty - data[i].SalDaiFaQty
                                            that.formInline.Lists[j].plan_deliver_qty = that.formInline.Lists[j].sales_qty - data[i].SalDaiFaQty
                                            that.formInline.Lists[j].qty_onhand = data[i].SalOnHandQty * data[i].Change_Rate
                                            that.formInline.Lists[j].qty_onyuliu = data[i].SalAssignQty * data[i].Change_Rate;
                                            that.formInline.Lists[j].move_direction = data[i].move_direction;
                                        }
                                    }
                                }
                            }
                        });
                    } else {
                        for (let i = 0; i < that.formInline.Lists.length; i++) {
                            if (val.exclusively_id == that.formInline.Lists[i].co_line_id) {
                                return false
                            }
                        }
                        that.formInline.Lists[that.wcentershowindex].co_line_part = val.sales_part;
                        that.formInline.Lists[that.wcentershowindex].part_version = val.part_version;
                        that.formInline.Lists[that.wcentershowindex].co_line_no = val.line_no;
                        that.formInline.Lists[that.wcentershowindex].co_line_id = val.exclusively_id;
                        that.formInline.Lists[that.wcentershowindex].co_line_part_id = val.sales_part_id;
                        that.formInline.Lists[that.wcentershowindex].sales_qty = val.sales_qty;
                        that.formInline.Lists[that.wcentershowindex].cuspart_id = val.cuspart_id;
                        that.formInline.Lists[that.wcentershowindex].cuspart_name = val.cuspart_name;
                        that.formInline.Lists[that.wcentershowindex].customer_item = val.customer_item;
                        that.formInline.Lists[that.wcentershowindex].package_size = val.package_size;
                        that.formInline.Lists[that.wcentershowindex].co_line_inv_part_num = val.part_no;
                        that.formInline.Lists[that.wcentershowindex].itemvernum = val.itemvernum; 
                        that.formInline.Lists[that.wcentershowindex].remark2 = val.remark2;                                                
                        that.formInline.Lists[that.wcentershowindex].remark1 = val.remark1;  
                        that.formInline.Lists[that.wcentershowindex].cus_chartnum = val.cus_chartnum;
                        that.formInline.Lists[that.wcentershowindex].spec = val.spec;
                        that.formInline.Lists[that.wcentershowindex].page_no = val.page_no;
                        
                        that.formInline.Lists[that.wcentershowindex].add = 0;
                        let parm = {
                            colineid: val.exclusively_id,
                            partid: val.part_no
                        };
                        that.$http.urlpost('/Sal/Out/GetSalPartRelationQty', parm, function (res) {
                            console.log(res);
                            if (res.Success == 1) {
                                let rate = val.change_rate;
                                that.formInline.Lists[that.wcentershowindex].need_deliver_qty = val.sales_qty - res.DataContent.SalDaiFaQty;
                                that.formInline.Lists[that.wcentershowindex].plan_deliver_qty = val.sales_qty - res.DataContent.SalDaiFaQty;
                                that.formInline.Lists[that.wcentershowindex].qty_onhand = res.DataContent.SalOnHandQty * rate;
                                that.formInline.Lists[that.wcentershowindex].qty_onyuliu = res.DataContent.SalAssignQty * rate;
                            }
                        });
                    }
                } else {
                    that.$message.error(that.$t('getapi[8774]'));//'数据重复'
                }
            },

            //删除行
            delline(e) {
                let line = e.$index;
                this.formInline.Lists.splice(line, 1);
                if (this.formInline.Lists.length <= 0) {
                    this.addline(0);
                }
            },
            //新增一行工艺清单
            addline(line) {
                let that = this;
                console.log(that.formInline.Lists);
                //that.formInline.Lists[line].add = true;
                let detail = that.formInline.Lists;
                let deti = {
                    add: false,
                    exclusively_id: 0,
                    relation_id: '',
                    line_no: line + 1,
                    co_line_id: 0,
                    co_line_no: '',
                    co_line_part: '',
                    part_version: '',
                    co_line_part_id: 0,
                    co_line_inv_part_num: 0,
                    sales_qty: 0,
                    need_deliver_qty: 0,
                    plan_deliver_qty: 0,
                    qty_onhand: 0,
                    qty_onyuliu: 0,
                    create_person: that.userinfo.username,
                    create_time: '',
                    remark: '',
                    status: 0,
                    statusname: '',
                    item_code: '',
                    item_name: '',
                    cuspart_id: '',
                    cuspart_name: '',
                    customer_item: 0,
                    package_size: 0,
                    isadd: 0,
                    move_direction:''
                };
                console.log('newdata', deti);
                that.formInline.Lists.push(deti);
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('salshipmentsinform',val);
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                console.log(parm);
                that.$http.urlpost('Sal/Out/GetSalPickNoticeList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            //获取详情
            getdlist(id) {
                let that = this;
                let parm = {
                    Code: id
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sal/Out/GetSalPickNoticeBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.formInline = res.DataContent;
                        that.formInline.Head.delivery_date = that.formInline.Head.delivery_date.replace(/\//g, '-');
                        console.log(that.formInline.Head.delivery_date);
                        that.formInline.Lists.forEach(function (item, index) {
                            item.add = true;
                            item.linid = index;
                        });
                        that.oldFormInline = JSON.stringify(that.formInline)
                        that.authority();
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(0)
                        })
                    }
                    loadingInstance.close()
                });
            },
            // 保存数据
            save() {
                let that = this;
                let arr = []
                for(let i = 0;i<that.formInline.Lists.length;i++){
                    arr = [...arr,{
                        "customer_order": that.formInline.Head.customer_order,
                        "line_no": that.formInline.Lists[i].co_line_no
                    }]
                }
                let parm = {
                    ls: arr,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Sal/Out/CheckSalNotice', parm, function (res) {
                    if (res.Success == 1) {
                        that.confirmSave()
                    } else if(res.Success == 2){
                        that.isShowDialog = true
                        that.title = res.Msg
                        that.content = res.PopupTxt
                    }
                });
            },
            confirmSave(){
                let that = this;
                that.isShowDialog = false
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.loading = true;
                let parm = that.formInline;
                parm.LangType = that.$processdata.getLang()
                /*parm.Lists.forEach(function (item, index) {
                    if (!item.add) {
                        parm.Lists.splice(index, 1);
                    }
                });*/
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Sal/Out/SalPickNoticeSaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        //that.intidata();
                        that.order_No = res.UniqueNum
                        that.getdlist(res.UniqueNum);
                        that.editvisi = false;
                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.formInline.IsConfirm = 1
                                let parm1 = that.formInline
                                parm1.LangType = that.$processdata.getLang()
                                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                                that.$http.urlpost('Sal/Out/SalPickNoticeSaveData', parm, function (res) {
                                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.intidata();
                                    that.order_No = res.UniqueNum
                                    that.getdlist(res.UniqueNum);
                                    that.editvisi = false;
                                })
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    that.loading = false;
                });
            },
            // 编辑
            edit(jsd) {
                console.log(jsd);
                let that = this;
                that.editvisi = true;
                that.editf = false;
                let code = jsd.row.ExClusively_Id;
                that.getdlist(code);
            },
            edits(jsd) {
                let that = this;
                if(that.order_No == jsd.ExClusively_Id){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 106, 1)){
                        return
                    }
                    let datacopy = that.formInline
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                        delete datacopy.Lists[i]['_XID']
                    }
                    if(that.oldFormInline != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldSelectIndex = that.act
                                that.iscontinuedblclick = true
                                that.oldrow = jsd
                                that.editvisi = true;
                                that.editf = false;
                                that.order_No = jsd.ExClusively_Id
                                that.getdlist(that.order_No);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.oldSelectIndex = that.act
                        that.iscontinuedblclick = true
                        that.oldrow = jsd
                        that.editvisi = true;
                        that.editf = false;
                        that.order_No = jsd.ExClusively_Id
                        that.getdlist(that.order_No);
                    }
                }, 100);
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectDetailData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].ExClusively_Id + ',';
                    that.selectDetailData.push(val[i]);
                }
                console.log(that.selectIDData);
            },
            imp() {
                let item = {
                    //label: '工艺导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/3',
                    url: '/exp/3',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/3'});
                this.$store.commit('selectMenu', item);
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('Basic/Items/DeleteItemByID', parm, function (res) {
                    that.intidata();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            // 删除
            // del(jsd) {
            //     this.ids = jsd.row.Exclusively_Id + ',';
            //     this.delf();
            // },
            //删除单据
            del() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//)'确定删除该单据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id:that.formInline.Head.exclusively_id,
                            customer_order:that.formInline.Head.customer_order,
                            status:that.formInline.Head.status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Sal/Out/DelSalPickNotice', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.confirmAdd();
                                that.authority();
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            movef(e) {
                this.formInline.direct_stuff_move_flag = e;
            },
            //冻结解冻
            enable(e) {
                let that = this;
                let parm = {
                    Id: 0,
                    Code: that.formInline.exclusively_id,
                    Name: '',
                    Where: ''
                };
                if (e) {
                    that.$http.urlpost('Eng/Routings/ThawRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.enable_flag = true;
                            that.formInlines.enable_flag = true;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                } else {
                    that.$http.urlpost('Eng/Routings/FrozenRoutingFlag', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.enable_flag = false;
                            that.formInlines.enable_flag = false;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }
            },
            // 可用/不可用
            status(e) {
                let that = this;
                let parm = {
                    partid: that.formInline.part_code,
                    routingid: that.formInline.exclusively_id,
                    routingversion: that.formInline.routing_version,
                    LangType: that.$processdata.getLang(),
                };
                if (e) {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledTrue', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = 1;
                            that.formInlines.version_status = true;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                } else {
                    that.$http.urlpost('Eng/Routings/RoutingEnabledFalse', parm, res => {
                        if (res.Success == 1) {
                            that.formInline.version_status = 0;
                            that.formInlines.version_status = false;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.formInline
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                    delete datacopy.Lists[i]['_XID']
                }
                if(that.oldFormInline != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this
                that.addoredit = 1
                that.order_No = ''
                this.formInline = {
                    IsConfirm: 0,
                    Head: {
                        exclusively_id: '',
                        customer_order: '',
                        field: '',
                        delivery_date: '',
                        delivery_person: '',
                        notice_person: this.userinfo.username,
                        create_person: '',
                        create_time: '',
                        status: 0,
                        statusname: '生成',
                        old_status: 0,
                        remark: '',
                        update_person: '',
                        update_date: '',
                        audit_person: '',
                        audit_time: '',
                        contract_info: '',
                        plan_delivery_date:'',
                    },
                    Lists: []
                };
                this.editvisi = true;
                this.editf = true;
                that.oldFormInline = JSON.stringify(that.formInline)
                this.authority();
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SALPickNoticeViewInfo ');
            },
            // 刷新
            reflash() {
                /*this.intidata();
                if (this.formInline.Head.exclusively_id) {
                    this.getdlist(this.formInline.Head.exclusively_id);
                }*/
                let that = this;
                let datacopy = that.formInline
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                    delete datacopy.Lists[i]['_XID']
                }
                if(that.oldFormInline != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            if (this.formInline.Head.exclusively_id) {
                                this.getdlist(this.formInline.Head.exclusively_id);
                            }
                        });
                } else {
                    this.intidata();
                    if (this.formInline.Head.exclusively_id) {
                        this.getdlist(this.formInline.Head.exclusively_id);
                    }
                }
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                    })
                    .catch(() => {
                    });
            },
            //导出·
            exp() {
                /*let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                that.$http.urlpost('Sal/Out/GetSalPickNoticeToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SALPickNoticeViewInfo",
                    fromname: that.$t('getapi[2822]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            //打印
            print() {
                //判断状态
                let that = this;
                if(that.$limits.fnIsEmpty(that.formInline.Head.exclusively_id)){
                    return;
                }
                that.loading = true;
                let parm = {
                    po_no: that.formInline.Head.exclusively_id,
                    notice_person: that.formInline.Head.notice_person,
                    create_time: that.formInline.Head.create_time,
                    customer_order: that.formInline.Head.customer_order,
                    delivery_date: that.formInline.Head.delivery_date,
                    TemplateName: '10发货通知单.xlsx'
                };
                that.$http.urlpost('/Print/SDPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            //获取下拉数据
            getselect() {
                let that = this;
                let parm = {};
                // 客户类型
                that.$http.urlpost('/Basic/Sale/GetCustomerTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.CustomerTypeList = res.DataContent;
                    }
                });
                // 销售类别
                that.$http.urlpost('/Basic/Sale/GetSalTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        that.SalTypeList = res.DataContent;
                    }
                });
                // 交货条款
                that.$http.urlpost('/Basic/Sale/GetDeliveryTermList', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeliveryTermList = res.DataContent;
                    }
                });
            },
            // 物料的工艺存在一个可用版本
            routingtwo() {
                let that = this;
                let parm = {
                    partid: that.formInline.part_code,
                    routingid: that.formInline.Exclusively_Id,
                    routingversion: that.formInline.routing_version
                };
                that.$http.urlpost('Eng/Routings/RoutingTwoEnabledTrue', parm, function (res) {
                    if (res.Success == 1) {
                        // that.$message.success();
                    }
                });
            },
            //从订单生成
            bathcre() {
                let that = this;
                let LanType = 1
                if(window.localStorage.getItem('lang')=='zh'){
                    LanType=1;
                }else if(window.localStorage.getItem('lang')=='en'){
                    LanType=2;
                }else if(window.localStorage.getItem('lang')=='hu'){
                    LanType=3;
                }
                let parm = {
                    Code: that.formInline.Head.customer_order,
                    LangType: LanType
                };
                that.$http.urlpost('/Sal/Out/SalNoticeFromPickNotice', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        let jsons = res.DataContent.DataList;
                        jsons.forEach(item => {
                            const has = that.formInline.Lists.some(items => {
                                return items.co_line_id === item.exclusively_id;
                            });
                            if (!has) {
                                let parmd = {
                                    line_no:item.line_no,
                                    co_line_part: item.sales_part,
                                    part_version: item.part_version,
                                    co_line_no: item.line_no,
                                    co_line_id: item.exclusively_id,
                                    co_line_part_id: item.sales_part_id,
                                    sales_qty: item.sales_qty,
                                    cuspart_id: item.cuspart_id,
                                    cuspart_name: item.cuspart_name,
                                    customer_item: item.customer_item,
                                    package_size: item.package_size,
                                    co_line_inv_part_num: item.part_no,
                                    need_deliver_qty: '',
                                    plan_deliver_qty: '',
                                    qty_onhand: '',
                                    qty_onyuliu: '',
                                    exclusively_id: '',
                                    relation_id: '',
                                    create_person: that.userinfo.username,
                                    create_time: '',
                                    remark: '',
                                    status: 0,
                                    statusname: '生成',
                                    item_code: '',
                                    item_name: '',
                                    remark2: item.remark2,
                                    itemvernum:item.itemvernum,
                                    remark1:item.remark1,
                                    cus_chartnum:item.cus_chartnum,
                                    spec:item.spec,
                                    page_no:item.page_no,
                                    add: true,
                                    isadd: 0
                                };
                                let parm = {
                                    colineid: item.exclusively_id,
                                    partid: item.part_no
                                };
                                console.log(parm);                                
                                that.$http.urlpost('Sal/Out/GetSalPartRelationQty', parm, function (res) {
                                    console.log(res);
                                    if (res.Success == 1) {
                                        let rate = item.change_rate;
                                        parmd.need_deliver_qty = item.sales_qty - res.DataContent.SalDaiFaQty;
                                        parmd.plan_deliver_qty = item.sales_qty - res.DataContent.SalDaiFaQty;
                                        parmd.qty_onhand = res.DataContent.SalOnHandQty * rate;
                                        parmd.qty_onyuliu = res.DataContent.SalAssignQty * rate;
                                        that.formInline.Lists.push(parmd);
                                    }
                                });
                            }
                        });
                    }
                });
            },
            //下达
            tall() {
                let that = this;
                let parm = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.status,
                    delivery_date: that.formInline.Head.delivery_date,
                    Lists: [],
                    LangType: that.$processdata.getLang(),
                };
                /*that.formInline.Lists.forEach(item => {
                    if (item.add) {
                        parm.Lists.push(item);
                    }
                });*/
                that.$http.urlpost('/Sal/Out/SalDNoticeRelease', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getdlist(that.order_No);
                    }
                });
            },
            // 确认关闭
            closes() {
                let that = this;
                let parm = {
                    exclusively_id: that.formInline.Head.exclusively_id,
                    status: that.formInline.Head.status,
                    concurrent_time: that.formInline.Head.update_date,
                };
                console.log("测试数据:"+JSON.stringify(parm))
                that.$http.urlpost('/Sal/Out/SalDNoticeClose', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getdlist(that.formInline.Head.exclusively_id);
                    }
                });
            },
            // 详情多选
            linedelsel({checked, records }) {
                let that = this;
                that.lineid = records;
                this.btnauthority();
            },
            linedelselAll({checked, records }) {
                let that = this;
                that.lineid = records;
                this.btnauthority();
            },
            //批量删除
            dellines() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.formInline.Head.exclusively_id,
                            status: that.formInline.Head.status,
                            customer_order: that.formInline.Head.customer_order,
                            Lists: []
                        };
                        for (let i = that.lineid.length - 1; i >= 0; i--) {
                            that.formInline.Lists.splice(that.lineid[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.lineid[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.lineid[i].exclusively_id,
                                    line_no: that.lineid[i].line_no
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Sal/Out/DelSalPickNoticeDetail', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getdlist(res.UniqueNum);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 新增s
            addlines() {
                let that = this;
                that.wcentershowindex = -1
                let param = {
                    currency_code:'',
                    customer_code:that.formInline.Head.customer_order,
                }
                that.$refs.input.clearInput(true, param);
                /*let that = this;
                let dlength = that.formInline.Lists.length;
                let detail = that.formInline.Lists;
                let deti = {
                    linid: dlength,
                    add: false,
                    exclusively_id: 0,
                    relation_id: '',
                    line_no: dlength + 1,
                    co_line_id: 0,
                    co_line_no: '',
                    co_line_part: '',
                    part_version: '',
                    co_line_part_id: 0,
                    co_line_inv_part_num: 0,
                    sales_qty: 0,
                    need_deliver_qty: 0,
                    plan_deliver_qty: 0,
                    qty_onhand: 0,
                    qty_onyuliu: 0,
                    create_person: that.userinfo.username,
                    create_time: '',
                    remark: '',
                    status: 0,
                    statusname: '',
                    item_code: '',
                    item_name: '',
                    cuspart_id: '',
                    cuspart_name: '',
                    customer_item: 0,
                    package_size: 0,
                    isadd: 0
                };
                that.formInline.Lists.push(deti);*/
            },

            //拖动条中间快捷按钮
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            //点击键盘触发
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            //按住键盘触发
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            //更新表格行状态
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    console.log(val, this.datajson);
                    let result = this.datajson.findIndex(item => item.ExClusively_Id === val.ExClusively_Id);
                    //this.indf = result;

                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            // 批量下单
            batchRelease(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectDetailData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectDetailData[i].ExClusively_Id
                    }]
                }
                let parm = {
                    List: arr,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Sal/Out/SalDNoticeBatchRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            // 批量关闭
            batchClose(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectDetailData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectDetailData[i].ExClusively_Id,
                        status:that.selectDetailData[i].Status
                    }]
                }
                let parm = {
                    List: arr,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Sal/Out/BatchCloseSalNotice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            // 批量删除
            batchDel(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectDetailData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectDetailData[i].ExClusively_Id,
                        status:that.selectDetailData[i].Status
                    }]
                }
                let parm = {
                    List: arr,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Sal/Out/BatchDelSalNotice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            expStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[2796]')//'待发货'
                } else if(val == 2){
                    return that.$t('getapi[441]')//'关闭'
                } else {
                    return ''
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 106,1) < 1){
                    return false
                }
                let datacopy = that.formInline
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                    delete datacopy.Lists[i]['_XID']
                }
                let flag =  that.oldFormInline != JSON.stringify(datacopy)
                return flag
            },
            // 排序
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.formInline.Lists.indexOf(obj1) - that.formInline.Lists.indexOf(obj2);
                        }
                    }
                    that.formInline.Lists.sort(compare);
                    that.formInline.Lists = [...that.formInline.Lists]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.formInline.Lists.indexOf(obj2) - that.formInline.Lists.indexOf(obj1);
                        }
                    }
                    that.formInline.Lists.sort(compare);
                    that.formInline.Lists = [...that.formInline.Lists]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
        }
    };
</script>

<style  scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.red{
        background: #74b9e7;
    }
    .el-dropdown {
        vertical-align: top;
        background-color: #ffd04b !important;
        border-color: #ffd04b !important;
        color: #ffffff;
        margin-left: 20px;
        padding: 0 14px;
        border-radius: 5px;
    }    
    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
            }
        }
    }

    span.titles {
        margin-left: 14px;
        margin-right: 15px;
        text-align: left;
        line-height: 40px;
        display: inline-block;
    }
</style>
